import React from 'react';

import { SimpleSelectorPresentational } from '../SimpleSelector';
import { FILTER_KEYS, VIEW, VIEW_LIVE } from '../../../../config/constants';
import { useRouter } from '../../../../helpers/customHooks';
import { useFiltersDispatch, useFiltersState, useTablePropertiesDispatch } from '../../../../store/hooks';
import { ViewMetricsSelectorPropsType } from './types';

const ViewMetricsSelector = ({ forceScope, liveTab, ...restProps }: ViewMetricsSelectorPropsType) => {
  
  const { specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  
  const {
    [liveTab? FILTER_KEYS.VIEW_LIVE : FILTER_KEYS.VIEW]: filterData = liveTab? VIEW_LIVE.types[VIEW_LIVE.defaultIndex] : VIEW.types[VIEW.defaultIndex]
  } = useFiltersState(specificScope, liveTab? FILTER_KEYS.VIEW_LIVE : FILTER_KEYS.VIEW);
  
  const { changeFilterData } = useFiltersDispatch();
  const { changeOrderColumn } = useTablePropertiesDispatch();
  return (
    <SimpleSelectorPresentational
      {...restProps}
      type={liveTab? VIEW_LIVE: VIEW}
      forceScope={forceScope}
      filterData={filterData}
      menuStyle={{ width: '198px', minWidth: '165px' }}
      changeFilterData={item => {
        changeFilterData(item, liveTab? FILTER_KEYS.VIEW_LIVE : FILTER_KEYS.VIEW, forceScope)();
        // Only for All Metrics Tab
        // eslint-disable-next-line default-case
        if(!liveTab){
        switch (item.value) {
          case VIEW.types[4].value: // 'Accels and Decels'
            changeOrderColumn(7, true)();
            break;
          case VIEW.types[5].value: // 'Zebra Team Summary'
            changeOrderColumn(5, true)();
            break;
          case VIEW.types[6].value: // 'Zebra Relative Summary'
            changeOrderColumn(5, true)();
        }
      }
      }}
    />
  );
};

export default ViewMetricsSelector;